import * as ROUTES from "../routes/route"; // wherever your constants are


export const ROUTE_EVENTS = {
  [ROUTES.HOME_ENDPOINT]: "home",
  [ROUTES.LOGIN_WITH_MOBILE_ENDPOINT]: "login_mobile",
  [ROUTES.LOGIN_WITH_EMAIL_ENDPOINT]: "login_email",
  [ROUTES.UPDATE_MOBILE_NUMBER_ENDPOINT]: "update_mobile",
  [ROUTES.VERIFICATION_ENDPOINT]: "verification",
  [ROUTES.NOT_FOUND_ENDPOINT]: "not_found",
  [ROUTES.SEARCH_ENDPOINT]: "search",
  [ROUTES.GUEST_LIST_ENDPOINT]: "guest_list",
  [ROUTES.SEARCH_RESULT_ENDPOINT]: "search_result",
  [ROUTES.VIEW_PROFILE_ENDPOINT]: "view_profile",
  [ROUTES.EDIT_PROFILE_ENDPOINT]: "edit_profile",
  [ROUTES.FORGOT_PASSWORD_ENDPOINT]: "forgot_password",
  [ROUTES.CREATE_PASSWORD_ENDPOINT]: "create_password",
  [ROUTES.ENTER_PASSWORD_ENDPOINT]: "enter_password",

  [ROUTES.VIEW_PRELIM_ASSESMENT_ENDPOINT]: "view_prelim_assessment",
  [ROUTES.ADD_PRELIM_ASSESMENT_ENDPOINT]: "add_prelim_assessment",
  [ROUTES.EDIT_PRELIM_ASSESMENT_ENDPOINT]: "edit_prelim_assessment",

  [ROUTES.VIEW_WELLBEING_REPORT_ENDPOINT]: "view_wellbeing_report",
  [ROUTES.PRINT_WELLBEING_REPORT_ENDPOINT]: "print_wellbeing_report",
  [ROUTES.VIEW_FULL_WELLBEING_REPORT_ENDPOINT]: "view_full_wellbeing_report",
  [ROUTES.EDIT_WELLBEING_REPORT_ENDPOINT]: "edit_wellbeing_report",
  [ROUTES.REOPEN_REPORT_FOR_GUEST_ENDPOINT]: "reopen_report",

  [ROUTES.VIEW_PREPARATORY_DIET_ENDPOINT]: "view_preparatory_diet",
  [ROUTES.EDIT_PREPARATORY_DIET_ENDPOINT]: "edit_preparatory_diet",

  [ROUTES.VIEW_CONSULTATION_NOTES_ENDPOINT]: "view_consultation_notes",
  [ROUTES.ADD_CONSULTATION_NOTES_ENDPOINT]: "add_consultation_notes",
  [ROUTES.EDIT_CONSULTATION_NOTES_ENDPOINT]: "edit_consultation_notes",

  [ROUTES.VIEW_SESSION_ENDPOINT]: "view_session",
  [ROUTES.VIEW_SESSION_NOTES_ENDPOINT]: "view_session_notes",
  [ROUTES.ADD_SESSION_NOTES_ENDPOINT]: "add_session_notes",
  [ROUTES.EDIT_SESSION_NOTES_ENDPOINT]: "edit_session_notes",

  [ROUTES.QUERY_ENDPOINT]: "queries",
  [ROUTES.CHAT_ENDPOINT]: "chat",

  [ROUTES.GROUP_CLASSESS_AND_ACTIVITY_ENDPOINT]: "group_classes_activity",
  [ROUTES.VIEW_GUEST_LIST_ENDPOINT]: "group_activity_guest_list",

  [ROUTES.STATUS_REPORT_ENDPOINT]: "status_report",

  [ROUTES.VIEW_TESTIMONIAL_ENDPOINT]: "view_testimonial",
  [ROUTES.VIEW_PROGRAMME_FEEDBACK_ENDPOINT]: "view_programme_feedback",

  [ROUTES.HELP_ENDPOINT]: "help",
  [ROUTES.VIEW_HELP_ENDPOINT]: "view_help",

  [ROUTES.RECOMMENDATIONS_ENDPOINT]: "recommendations"
};